// src/features/live-shuttle/redux/live-shuttle-api.ts

import { appApi } from "@src/integrations/redux/app-api";
import { HTTP_METHODS } from "@src/utils/network-constants";
import {
  urlForLiveShuttleSummary,
  urlForRecentLiveShuttles,
} from "@src/features/live-shuttles/live-shuttle-api-urls";
import type {
  LiveShuttleSummary,
  RecentLiveShuttle,
} from "@src/features/live-shuttles/live-shuttle-models";
import type {
  GetLiveShuttleSummaryArgs,
  GetRecentLiveShuttlesArgs,
} from "@src/features/live-shuttles/live-shuttle-dtos";

export const liveShuttleApi = appApi.injectEndpoints({
  endpoints: (builder) => ({
    getLiveShuttleSummary: builder.query<
      { data: LiveShuttleSummary },
      GetLiveShuttleSummaryArgs
    >({
      query: ({ spaceId, date }) => ({
        url: `${urlForLiveShuttleSummary(spaceId)}?date=${date}`,
        method: HTTP_METHODS.GET,
      }),
    }),

    getRecentLiveShuttles: builder.query<
      { data: RecentLiveShuttle[] },
      GetRecentLiveShuttlesArgs
    >({
      query: ({ spaceId, date, limit }) => ({
        url: `${urlForRecentLiveShuttles(spaceId)}?date=${date}&limit=${limit}`,
        method: HTTP_METHODS.GET,
      }),
    }),
  }),
  overrideExisting: "throw",
});

export const {
  useGetLiveShuttleSummaryQuery,
  useGetRecentLiveShuttlesQuery,
} = liveShuttleApi;
